module.exports = __webpack_public_path__ + "static/media/mode-570.347c3751.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-570.svg
// module id = 1060
// module chunks = 2